import moment from 'moment-timezone';
import i18n from '~/utils/i18n';
import { availableFilters as genericFilters, visibleFields } from './generic.js';

export const endpoint = 'customers/search';

export const allFields = {
  name: {
    label: 'name',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.name'),
  },
  contact_person_name: {
    label: 'contact_person_name',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.contact_person_name'),
  },
  email: {
    label: 'email',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.email'),
  },
  phone: {
    label: 'phone',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.phone'),
  },
  created_at: {
    label: 'created_at',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.created_at'),
    translateCell: (data) => {
      if (data !== null && moment(data).isValid()) {
        return i18n.t('fn.date', { timestamp: data });
      }
      return null;
    },
  },
  id: {
    label: 'id',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.id'),
  },
  remote_id: {
    label: 'remote_id',
    sortable: true,
    translateColumn: () => i18n.t('customer_field.title.remote_id'),
  },
};

export function availableFields(disabledFields) {
  return visibleFields(disabledFields, allFields);
}

export const enabledFields = [
  'name',
  'contact_person_name',
  'email',
  'phone',
  'created_at',
];

export const enabledFieldsMD = [
  'name',
  'email',
  'phone',
];

export const enabledFieldsSM = [
  'name',
  'email',
];

export const availableFilters = [
  ...genericFilters,
];



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/search-models/customer.js